var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.02701 16.7L4.23764 12.9106M4.23764 12.9106L8.02701 9.12128M4.23764 12.9106H17.5004M11.8164 16.7V17.6474C11.8164 18.4011 12.1158 19.124 12.6488 19.657C13.1818 20.19 13.9046 20.4894 14.6584 20.4894H18.4478C19.2015 20.4894 19.9244 20.19 20.4574 19.657C20.9904 19.124 21.2898 18.4011 21.2898 17.6474V8.17393C21.2898 7.42018 20.9904 6.6973 20.4574 6.16432C19.9244 5.63134 19.2015 5.33191 18.4478 5.33191H14.6584C13.9046 5.33191 13.1818 5.63134 12.6488 6.16432C12.1158 6.6973 11.8164 7.42018 11.8164 8.17393V9.12128",
    stroke: "#2D3748",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogout);
export default __webpack_public_path__ + "static/media/menu_logout.5dd0eabcd2fe27b8d12e8a389569594f.svg";
export { ForwardRef as ReactComponent };